import { render, staticRenderFns } from "./PublisherSetupTab.vue?vue&type=template&id=01f11a7f"
import script from "./PublisherSetupTab.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTab.vue?vue&type=script&lang=js"
import style0 from "./PublisherSetupTab.vue?vue&type=style&index=0&id=01f11a7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports